<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备类型：</span>
        </div>
        <el-select v-model="formData.deviceType" size="small" style="width: 280px" disabled>
          <el-option v-for="item in deviceTypeList" :key="item.deviceType"
                     :label="item.name" :value="item.deviceType">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备名称：</span>
        </div>
        <el-input v-model="formData.deviceName" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备编号：</span>
        </div>
        <el-input v-model="formData.deviceCode" size="small" style="width: 280px" disabled/>
      </div>

      <div class="form-line">
        <div class="textBox">
          <!--          <b class="red">*</b>-->
          <span class="line-text">设备厂商：</span>
        </div>
        <el-input v-model="formData.deviceManufacturerName" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <!--          <b class="red">*</b>-->
          <span class="line-text">设备型号：</span>
        </div>
        <el-input v-model="formData.deviceModelName" size="small" style="width: 280px"/>
      </div>

    <div v-if="tabName=='second'">
      <div v-if="formData.deviceType === 'S2'">
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">温度最小阈值：</span>
          </div>
          <el-input v-model="formData.thresholdMin" size="small" style="width: 280px"  oninput="value=value.replace(/^\.+|[^\d.]/g,'')"/>
        </div>

        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">温度最大阈值：</span>
          </div>
          <el-input v-model="formData.thresholdMax" size="small" style="width: 280px"  oninput="value=value.replace(/^\.+|[^\d.]/g,'')"/>
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">湿度最小阈值：</span>
          </div>
          <el-input v-model="formData.resThresholdMin" size="small" style="width: 280px"  oninput="value=value.replace(/^\.+|[^\d.]/g,'')"/>
        </div>

        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">湿度最大阈值：</span>
          </div>
          <el-input v-model="formData.resThresholdMax" size="small" style="width: 280px"  oninput="value=value.replace(/^\.+|[^\d.]/g,'')"/>
        </div>
      </div>

      <div v-else-if="formData.deviceType === 'S4'">
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">电压最小阈值：</span>
          </div>
          <el-input v-model="formData.thresholdMin" size="small" style="width: 280px"  oninput="value=value.replace(/^\.+|[^\d.]/g,'')"/>
        </div>

        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">电压最大阈值：</span>
          </div>
          <el-input v-model="formData.thresholdMax" size="small" style="width: 280px"  oninput="value=value.replace(/^\.+|[^\d.]/g,'')"/>
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">电流最小阈值：</span>
          </div>
          <el-input v-model="formData.resThresholdMin" size="small" style="width: 280px"  oninput="value=value.replace(/^\.+|[^\d.]/g,'')"/>
        </div>

        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">电流最大阈值：</span>
          </div>
          <el-input v-model="formData.resThresholdMax" size="small" style="width: 280px"  oninput="value=value.replace(/^\.+|[^\d.]/g,'')"/>
        </div>
      </div>

      <div v-else>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">最小阈值：</span>
          </div>
          <el-input v-model="formData.thresholdMin" size="small" style="width: 280px"  oninput="value=value.replace(/^\.+|[^\d.]/g,'')"/>
        </div>

        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">最大阈值：</span>
          </div>
          <el-input v-model="formData.thresholdMax" size="small" style="width: 280px"  oninput="value=value.replace(/^\.+|[^\d.]/g,'')"/>
        </div>
      </div>
    </div>
<!--      <div class="form-line" v-if="tabName=='second'">-->
<!--        <div class="textBox">-->
<!--          <b class="red">*</b>-->
<!--          <span class="line-text">最小阈值：</span>-->
<!--        </div>-->
<!--        <el-input v-model="formData.thresholdMin" size="small" style="width: 280px" />-->
<!--      </div>-->

<!--      <div class="form-line" v-if="tabName=='second'">-->
<!--        <div class="textBox">-->
<!--          <b class="red">*</b>-->
<!--          <span class="line-text">最大阈值：</span>-->
<!--        </div>-->
<!--        <el-input v-model="formData.thresholdMax" size="small" style="width: 280px" />-->
<!--      </div>-->

      <div class="form-line">
        <div class="textBox">
          <!--          <b class="red">*</b>-->
          <span class="line-text">所属场所：</span>
        </div>
        <el-select v-model="formData.bindPlaceCode" size="small" style="width: 280px">
          <el-option v-for="item in powerRoomList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <!--          <b class="red">*</b>-->
          <span class="line-text">关联网关：</span>
        </div>
        <el-select v-model="formData.bindGatewayCode" size="small" style="width: 280px">
          <el-option v-for="item in environmentGatewayDeviceList" :key="item.deviceCode"
                     :label="item.deviceName" :value="item.deviceCode">
          </el-option>
        </el-select>
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import TextTitle from '../../../components/Text/TextTitle'
import ButtonConfirm from '../../../components/Button/ButtonConfirm'
import ButtonCancel from '../../../components/Button/ButtonCancel'
import {getObjectURL} from '../../../utils/toBase64'
import {bus} from '../../../utils/bus'
import {api} from '../../api/SmartDetection'
import {nError, nSuccess} from '../../../utils/notice'
import {errorHandler} from '../../../utils/errorHandler'

export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb},
  name: 'smart-detection-probe-add',
  data () {
    return {
      breadcrumb: [{
        value: '配电监测',
        name: 'smart-detection-over-view'
      }, {
        value: '传感器管理'
      }],
      mainTitle: '修改传感器',
      subheading: '',

      deviceTypeList: [
        {deviceType: 'S0', name: '液位传感器'},
        {deviceType: 'S1', name: '液压传感器'},
        {deviceType: 'S2', name: '温湿度传感器'},
        {deviceType: 'S3', name: '水质传感器'},
        {deviceType: 'S4', name: '电压/电流传感器'},
        {deviceType: 'S5', name: '风速传感器'},
        {deviceType: 'S6', name: '气压传感器'},
        {deviceType: 'S7', name: '高度传感器'},
      ],
      deviceManufacturerList: [
        {code: '大麦物联', name: '大麦物联'}
      ],
      deviceModelNameList: [
        {code: 'DM-IOTC-PD-E', name: 'DM-IOTC-PD-E'},
      ],
      powerRoomList: [],
      environmentGatewayDeviceList: [],
      formData: {
        deviceType: 'S0',
        deviceName: '',
        deviceCode: '',
        upperSite: '',
        runTime: '',
        deviceManufacturerName: '',
        deviceModelName: '',
        svg: '',
        vg: '',
        ir: '',
        rc: '',
        powerRoomCode: '',
        powerRoomName: '',
        energyGatewayDeviceCode: '',
        energyGatewayDeviceName: '',
      },
      tabName:'',
      code:''


    }
  },
  created () {
    this.code=this.$route.params.code
    this.tabName=this.$route.params.tabName
    this.getPowerRoomList()
    this.getEnvironmentGatewayList()
    this.getStatusDetectorByCode()
  },
  methods: {
    getStatusDetectorByCode(){
      let url='';
      if (this.tabName=='second'){
        url=api.getStatusDetectorByCode
      }else if(this.tabName=='third'){
        url=api.getTouchDetectorByCode
      }else if(this.tabName=='fourth'){
        url=api.getPumpDetectorByCode
      }
      this.$axios.get(url+'/'+this.code).then(res=>{
        this.formData=res.data.data
      }).catch(errorHandler("获取详情失败"))
    },
    getPowerRoomList () {
      this.$axios.post(`${api.getPlaceList}`, {})
        .then(res => {
          let list = res.data.data
          this.powerRoomList = list
        })
        .catch(errorHandler('查询场所失败'))
    },

    getEnvironmentGatewayList () {
      this.$axios.post(`${api.getGatewayDeviceList}`, {})
        .then(res => {
          let list = res.data.data
          this.environmentGatewayDeviceList = list
        })
        .catch(errorHandler('查询电压采集网关失败'))
    },

    toManagementPage () {
      this.$router.push({
        name: 'smart-detection-power-distribution-cabinet-manage'
      })
    },

    // 修改
    confirm () {
      if (!this.formData.deviceName) {
        nError('请输入设备名称')
        return false
      }
      if (!this.formData.deviceCode) {
        nError('请输入设备编号')
        return false
      }
      this.powerRoomList.map(v => {
        if (v.code === this.formData.bindPlaceCode) {
          this.formData.bindPlaceName = v.name
        }
      })
      this.environmentGatewayDeviceList.map(v => {
        if (v.deviceCode === this.formData.bindGatewayCode) {
          this.formData.bindGaetwayName = v.deviceName
        }
      })
      let url='';
       if (this.tabName=='second'){
        url=api.updateStatusDetector
      }else if(this.tabName=='third'){
        url=api.updateTouchDetector
      }else if(this.tabName=='fourth'){
        url=api.updatePumpDetector
      }
      this.$axios.post(url, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('修改成功')
            this.toManagementPage()
          }
        })
        .catch(errorHandler('修改失败'))
    },

    cancel () {
      this.toManagementPage()
    }
  }
}
</script>

<style scoped>
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #FF0000;
  vertical-align: sub;
}
.form-line {
  margin: 20px 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.form-line>div {
  margin-right: 20px;
}
.line-text{
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 190px;
  line-height: 32px;
  text-align: right;
}
.form-btn-box {
  width: 530px;
  padding: 0 110px 0 140px;
  margin: 40px 0 0 0;
  display: flex;
  justify-content: space-between;
}
.newly2 {
  display: inline-block;
  width: 250px;
  height: 173px;
  vertical-align: text-top;
  border: 1px dashed #D7D7D7;
  margin-right: 20px;
  position: relative;
}
.newly2 span {
  display: block;
  width: 100%;
  color: #999999;
  margin: 0;
  padding: 0;
  text-align: center;
}
.newly2 span:first-child {
  font-size: 36px;
  line-height: 120px;
  position: absolute;
  top: 15px;
}
.newly2 span:last-child {
  font-size: 14px;
  line-height: 50px;
  position: absolute;
  bottom: 0;
}
.upload2 {
  display: inline-block;
  width: 250px;
  height: 173px;
  vertical-align: text-top;
  background-size: 100% 100%;
  position: relative;
}

.upload2 img {
  width: 100%;
  height: 100%;
  border-radius: 5px;
}
.upload2 b {
  display: inline-block;
  width: 100%;
  line-height: 21px;
  color: white;
  background-color: #989796;
  text-align: center;
  position: absolute;
  bottom: 0;
  opacity: .7;
}
</style>

<style lang="less">
.el-switch {
  height: 30px;
}
</style>




// WEBPACK FOOTER //
// src/view/SmartDetection/SmartDetectionProbe/SmartDetectionProbeModify.vue